import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "../../../../../Uri";
import {
  Container,
  Grid,
  Backdrop,
  CircularProgress,
  Button,
} from "@mui/material";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import DateTimePicker from "../../../../../layouts/profile/GuestLoginForm/components/DataTimePicker";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const FORM_VALIDATION = Yup.object().shape({
  noticeDate: Yup.date()
  .test(
    "Notice Date",
    " Notice Date Cant Be more than 3 past days 🥱🥳",
    (date) => moment().diff(moment(date), "days") <= 4
    // moment(date).format("DD-MM-YYYY") >= moment(new Date()).format("DD-MM-YYYY")
  )
  .required("Required"),
    // .test(
    //   "Transaction date",
    //   "Please choose a valid planned checkOut date date 🥱🥳",
    //   (date) => moment().diff(moment(date), "years") <= 8
    // ),
});
const InitiateCheckoutBtn = (props) => {
  const [INITIAL_FORM_STATE, setINITIAL_FORM_STATE] = React.useState({
    id: props.guestdetails.id,
    occupancyType: props.guestdetails.occupancyType,
    noticeDate: props.guestdetails.noticeDate,
   // plannedCheckOutDate: props.guestdetails.plannedCheckOutDate,
  });
  const [disableButtons, setDisableButtons] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const closeLoading = () => setLoading(!loading);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const handleDisable = () => {
    setDisableButtons(true);
      }

  
  return (
    <Grid container>
      <Grid item xs={12}>
        <Container maxWidth="md">
          <div>
            <Formik
              initialValues={{ ...INITIAL_FORM_STATE }}
              validationSchema={FORM_VALIDATION}
              onSubmit={async (guest) => {
                console.log(guest);
                if(guest.noticeDate ==null){
                 toast.error("Planned Checkout is After Notice Date")
                }
                else{
                  console.log("not error")
                  handleToggle();
                  await axios
                  .post(
                    `guest/initiatecheckoutbyguestid/${props.guestdetails.id}`,
                    guest
                  )
                  .then((res) => {
                    console.log(res);
                    if (res.status === 200) {
                      handleClose();
                      setDisableButtons(true);
                      toast.success(
                        "Guest check out is initiated successfully have a good day !",
                        {
                          position: toast.POSITION.TOP_CENTER,
                        }
                      );
                    }
                  });
                }
               
              }}
            >
              {() => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <h5>NoticeDate</h5>
                      <DateTimePicker
                        inputProps={{
                          min: moment(new Date).format("DD-MM-YYYY"),
                        }}
                      
                        // maxdate={new Date()}
                        name="noticeDate"
                        required
                        // onChange={(e)=>console.log(e.target.value)}
                      />
                    </Grid>
                
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <Button
                        sx={{ mb: 4 }}
                        disabled={disableButtons}
                        variant="contained"
                        color="primary"
                        type="submit"
                        style={{
                          margin: "20px",
                          color: "white",
                          align: "center",
                        }}
                        // onClick={() => {
                        //   {
                        //     handleDisable
                        //   }
                        // }}
                      >
                        INITIATE
                      </Button>
                    </Grid>
                  </Grid>
                  <ToastContainer
                    maxWidth="sx"
                    position="POSITION.TOP_CENTER"
                    autoClose={2000}
                    type="toast.TYPE.SUCCESS"
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </Form>
              )}
            </Formik>
          </div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Container>
      </Grid>
    </Grid>
  );
};
export default InitiateCheckoutBtn;
